import {  Modal,  ModalContent,  ModalOverlay } from '@chakra-ui/react';
import React from 'react';
import { ColorRing } from 'react-loader-spinner';


const Loading: React.FC = () => {


  return (
    <Modal isOpen onClose={() =>{}} size="full" >
      <ModalOverlay />
      <ModalContent style={{display: 'flex', alignItems:'center', justifyContent: 'center', backgroundColor: 'transparent'}}>
        <ColorRing
          visible={true}
          height="80"
          width="80"
          ariaLabel="blocks-loading"
          wrapperStyle={{}}
          wrapperClass="blocks-wrapper"
          colors={['#00ff12', '#00ff12', '#00ff12','#00ff12','#00ff12']}
        />
      </ModalContent>
    </Modal>
  );
}

export default Loading;
